import { render, staticRenderFns } from "./Goods_edit.vue?vue&type=template&id=0b06c914&scoped=true&"
import script from "./Goods_edit.vue?vue&type=script&lang=js&"
export * from "./Goods_edit.vue?vue&type=script&lang=js&"
import style0 from "./Goods_edit.vue?vue&type=style&index=0&id=0b06c914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06c914",
  null
  
)

export default component.exports